import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import apiClient from "@/lib/api";

export function usePageTracking(isAuthenticated: boolean) {
  const location = useLocation();
  const enteredAt = useRef<number>(Date.now());
  const prevPath = useRef<string>(location.pathname);

  useEffect(() => {
    if (!isAuthenticated) return;

    const path = prevPath.current;
    const duration_ms = Math.round(Date.now() - enteredAt.current);

    if (duration_ms > 500) {
      apiClient
        .post("/analytics/page-view", { path, duration_ms })
        .catch(() => {});
    }

    prevPath.current = location.pathname;
    enteredAt.current = Date.now();
  }, [location.pathname, isAuthenticated]);

  // Flush on tab close / navigate away
  useEffect(() => {
    if (!isAuthenticated) return;

    const flush = () => {
      const duration_ms = Math.round(Date.now() - enteredAt.current);
      if (duration_ms <= 500) return;
      const payload = JSON.stringify({
        path: prevPath.current,
        duration_ms,
      });
      navigator.sendBeacon(
        `${apiClient.defaults.baseURL ?? ""}/analytics/page-view`,
        new Blob([payload], { type: "application/json" }),
      );
    };

    window.addEventListener("beforeunload", flush);
    return () => window.removeEventListener("beforeunload", flush);
  }, [isAuthenticated]);
}
